import Dashboard from '../containers/dashboard'
import PaymentPendingRoutingDetailsManagement from '../containers/payment-pending-routing-details-management'

const PaymentPendingRoutingDetails = () => {
  return (
    <Dashboard>
      <PaymentPendingRoutingDetailsManagement />
    </Dashboard>
  )
}

export default PaymentPendingRoutingDetails
